"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLandParams = void 0;

var _utils = require("../../../utils");

var _utils2 = require("../components/DatePicker/components/Calendar/utils");

var _constants = require("../constants");

var _differenceInDays = _interopRequireDefault(require("date-fns/differenceInDays"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildLandParams = function buildLandParams(_ref) {
  var departure = _ref.departure,
      destination = _ref.destination,
      datepicker = _ref.datepicker,
      tourists = _ref.tourists,
      host = _ref.host,
      searchType = _ref.searchType;

  if (searchType === _constants.SEARCH_TYPE_NAMES.TRIP) {
    return {
      redirectUrl: destination['url'].replace('experience.tripster.ru', 'promo.level.travel/excursions#'),
      searchType: searchType
    };
  } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore


  return _objectSpread(_objectSpread(_objectSpread({}, destinationParams(destination)), {}, {
    from_city: searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE ? departure.value : 'any',
    from_country: departure ? departure.iso2 || _constants.DEFAULT_DEPARTURE_COUNTRY_ISO2 : _constants.DEFAULT_DEPARTURE_COUNTRY_ISO2,
    adults: tourists.adults,
    kids: tourists.kids.length,
    kids_ages: tourists.kids.join(',')
  }, datesParams(datepicker)), {}, {
    host: host,
    search_type: searchType
  });
};

exports.buildLandParams = buildLandParams;

var destinationParams = function destinationParams(_ref2) {
  var groupName = _ref2.groupName,
      value = _ref2.value,
      iso2 = _ref2.iso2,
      country = _ref2.country;

  switch (groupName) {
    case 'hotels':
      return {
        hotel_ids: value,
        to_country: iso2
      };

    case 'metaregions':
    case 'allMetaregions':
      return {
        to_metaregion: value
      };

    case 'countries':
    case 'popularCountries':
    case 'allCountries':
      return {
        to_country: iso2
      };

    case 'popularDirections':
      return {
        to_city: value,
        to_country: country === null || country === void 0 ? void 0 : country.iso2
      };

    default:
      return {
        to_city: value,
        to_country: iso2
      };
  }
};

var getFormattedCornerDates = function getFormattedCornerDates(dateCell, shift) {
  var dates = (0, _utils2.getCornerDates)({
    date: dateCell.date,
    shift: shift
  });
  return {
    from: (0, _utils.formatServerDate)(dates.from),
    to: (0, _utils.formatServerDate)(dates.to)
  };
};

var flexStartDates = function flexStartDates(dateCell, shift) {
  var startDates = getFormattedCornerDates(dateCell, shift);
  return {
    start_date_from: startDates.from,
    start_date_till: startDates.to
  };
};

var flexEndDates = function flexEndDates(dateCell, shift) {
  var endDates = getFormattedCornerDates(dateCell, shift);
  return {
    end_date_from: endDates.from,
    end_date_till: endDates.to
  };
};

var datesParams = function datesParams(_ref3) {
  var left = _ref3.left,
      right = _ref3.right,
      shift = _ref3.shift;
  var startDatePrimary = (0, _utils.convertServerDateToClientDate)(left.date);

  if (right.date && left.date) {
    var nights = (0, _differenceInDays["default"])(right.date, left.date);
    return {
      start_date: startDatePrimary,
      nights: Number(nights),
      flex_dates: shift
    };
  }
  /**
   * Все что ниже в этой функции непонятно от слова СОВСЕМ
   */


  var startDates = flexStartDates(left, shift);
  var endDates = flexEndDates(right, shift);

  if (right.date) {
    return _objectSpread(_objectSpread(_objectSpread({}, flexStartDates(left, shift)), flexEndDates(right, shift)), {}, {
      start_date_primary: startDatePrimary,
      end_date_primary: (0, _utils.convertServerDateToClientDate)(right.date)
    });
  }

  return _objectSpread(_objectSpread({}, startDates), endDates);
};